<template>
    <div>
        <vue-perfect-scrollbar style="height: 408px" :settings="settings">
            <v-data-table :headers="headers" :items="dashboard_nonconformances || []" :no-data-text="$t('lang.loading')" hide-actions
                ><template slot="items" slot-scope="props">
                    <tr class="clickable" @click="$refs.nonconformance.showNonconformance(props.item)">
                        <td>{{ props.item.object_name_display }}</td>
                        <td>{{ props.item.type }}</td>
                        <td>{{ props.item.nonconformance_qty }}</td>
                        <td>{{ props.item.description }}</td>
                        <td>{{ props.item.reason_code_id }}</td>
                        <td>{{ props.item.date_created }}</td>
                        <td>{{ props.item.created_by }}</td>
                    </tr>
                </template></v-data-table
            >
        </vue-perfect-scrollbar>
        <bc-btn-nonconformance ref="nonconformance" no-button state-property="dashboard_nonconformances"></bc-btn-nonconformance>
    </div>
</template>
<script>
import api from "Api";
import { mapState, mapActions } from "vuex";
export default {
    data() {
        return {
            loader: true,
            settings: {
                maxScrollbarLength: 160,
            },
            headers: [
                {
                    text: this.$t("lang.origin"),
                    sortable: false,
                },
                {
                    text: this.$t("lang.type"),
                    sortable: false,
                },
                {
                    text: this.$t("lang.qty"),
                    sortable: false,
                },
                {
                    text: this.$t("lang.description"),
                    sortable: false,
                },
                {
                    text: this.$t("lang.reason_code_id"),
                    sortable: false,
                },
                {
                    text: this.$t("lang.date_created"),
                    sortable: false,
                },
                {
                    text: this.$t("lang.created_by"),
                    sortable: false,
                },
            ],
            qc_inspections: [],
        };
    },
    mounted() {
        if (this.dashboard_nonconformances == null) this.getNonconformances();
    },
    computed: {
        ...mapState({
            dashboard_nonconformances: (state) => state.nonconformance.dashboard_nonconformances,
        }),
    },
    methods: {
        getNonconformances(refresh = false) {
            if (refresh) {
                this.$store.commit("commitNonconformance", {
                    property: "dashboard_nonconformances",
                    with: null,
                });
            }

            this.$store.dispatch("fetchNonconformance", {
                url: "nonconformance",
                method: "get",
                stateProperty: "dashboard_nonconformances",
                dataProperty: "nonconformances",
                commit: true,
                body: {
                    page_size: 10,
                    page_num: 1,
                },
            });
        },
    },
};
</script>
